<template>
  <div>
    <div style="z-index: -999;margin-bottom: 50px;margin-top: 20px">
      <Carousel autoplay v-model="value2" loop>
        <CarouselItem>
          <div class="demo-carousel"><img style="height: 100%;width: 100%" src="../assets/zhaozu.png"/></div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel"><img style="height: 100%;width: 100%"  src="../assets/zhaozu.png"/></div>
        </CarouselItem>
      </Carousel>
    </div>
    <div>
      <span style="font-size: 20px;">商品供应</span>
      <h5><img src="../assets/blue.png"></h5>
      <div style="margin-top: 20px;margin-left: 10%;margin-right: 10%;margin-bottom: 50px;">
        <Row style="text-align: right;margin-right: 5%">
          <Col>
          <a @click="CommodityChange" style="font-size: 18px;">更多></a>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="4" style="text-align: right">
          <span style="font-size: 20px;flood-color: #ed4014">分类：</span>
          </Col>
          <Col span="20" style="text-align: left">
          <RadioGroup v-model="publish" type="button" @on-change="radioPublish(publish)">
            <Radio label="全部"></Radio>
            <Radio label="服饰"></Radio>
            <Radio label="数码"></Radio>
            <Radio label="配件配饰"></Radio>
            <Radio label="家具"></Radio>
          </RadioGroup>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="4" style="text-align: right">
          <span style="font-size: 20px;flood-color: #ed4014">价格：</span>
          </Col>
          <Col span="20" style="text-align: left">
          <RadioGroup>
            <Radio label="0-100"></Radio>
            <Radio label="100-200"></Radio>
            <Radio label="200-500"></Radio>
            <Radio label="500-1000"></Radio>
            <Radio label="1000+"></Radio>
          </RadioGroup>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="4" style="text-align: right">
          <span style="font-size: 20px;flood-color: #ed4014">上架时间：</span>
          </Col>
          <Col span="20" style="text-align: left">
          <DatePicker type="daterange" placement="bottom-end" placeholder="Select date" style="width: 200px"></DatePicker>
          </Col>
        </Row>
        <Row align="middle" style="margin-top: 100px;">
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity01"><img style="width: 300px;height: 300px;" src="../assets/commodity/01/00.jpg"/>
            </a>
          </div>
          </Col>
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity02"><img style="width: 300px;height: 300px;" src="../assets/commodity/02/00.jpg"/></a>
          </div>
          </Col>
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity03"><img style="width: 300px;height: 300px;" src="../assets/commodity/03/00.jpg"/></a>
          </div>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <a @click="changeCommodity01" style="font-family: 楷体;font-size: 20px;font-weight: bold">风阻液阻划水机￥1599</a>
          </Col>
          <Col span="8">
          <a @click="changeCommodity02" style="font-family: 楷体;font-size: 20px;font-weight: bold">腹肌贴￥518</a>
          </Col>
          <Col span="8">
          <a @click="changeCommodity03" style="font-family: 楷体;font-size: 20px;font-weight: bold">自动回弹健腹轮￥418</a>
          </Col>
        </Row>
        <Row align="middle" style="margin-top: 100px;">
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity04"><img style="width: 300px;height: 300px;" src="../assets/commodity/04/00.jpg"/>
            </a>
          </div>
          </Col>
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity05"><img style="width: 300px;height: 300px;" src="../assets/commodity/05/00.jpg"/></a>
          </div>
          </Col>
          <Col span="8">
          <div style="text-align:center">
            <a @click="changeCommodity06"><img style="width: 300px;height: 300px;" src="../assets/commodity/06/00.jpg"/></a>
          </div>
          </Col>
        </Row>
        <Row>
          <Col span="8">
          <a @click="changeCommodity04" style="font-family: 楷体;font-size: 20px;font-weight: bold">手表￥428</a>
          </Col>
          <Col span="8">
          <a @click="changeCommodity05" style="font-family: 楷体;font-size: 20px;font-weight: bold">休闲百搭网鞋刀锋鞋运动鞋￥248</a>
          </Col>
          <Col span="8">
          <a @click="changeCommodity06" style="font-family: 楷体;font-size: 20px;font-weight: bold">真皮时尚休闲板鞋￥268</a>
          </Col>
        </Row>
      </div>
    </div>
    <span style="font-size: 20px;">热门需求</span>
    <h5><img src="../assets/blue.png"></h5>
    <div style="margin-top: 50px;margin-left: 10%;margin-right: 10%;margin-bottom: 50px;">
      <Row style="text-align: right;margin-right: 5%">
        <Col>
        <a  @click="PublishChange" style="font-size: 18px;">更多></a>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">分类：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup type="button">
          <Radio label="全部"></Radio>
          <Radio label="生活服务"></Radio>
          <Radio label="房屋出租"></Radio>
          <Radio label="技术转让"></Radio>
          <Radio label="兼职招聘"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">价格：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup>
          <Radio label="0-100"></Radio>
          <Radio label="100-200"></Radio>
          <Radio label="200-500"></Radio>
          <Radio label="500-1000"></Radio>
          <Radio label="1000+"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">上架时间：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <DatePicker type="daterange" placement="bottom-end" placeholder="Select date" style="width: 200px"></DatePicker>
        </Col>
      </Row>
      <Row align="middle" style="margin-top: 100px;">
        <Col span="8">
        <div style="text-align:center">
          <a @click="changePublish01"><img style="width: 300px;height: 300px;" src="#"/>
          </a>
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <a @click="changePublish01" style="font-family: 楷体;font-size: 20px;font-weight: bold">免费Ps修图 新人练手 欢迎联系</a>
        </Col>
      </Row>
    </div>
    <span style="font-size: 20px;margin-top: 50px">信息发布</span>
    <h5><img src="../assets/blue.png"></h5>
    <RadioGroup v-model="publish" type="button" @on-change="radioPublish(publish)">
      <Radio label="商品"></Radio>
      <Radio label="需求"></Radio>
    </RadioGroup>
    <div v-if="commodity" style="margin-top: 50px;margin-bottom: 50px;background-color: dimgrey;padding-bottom: 50px;padding-top: 50px">
      <Form>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
            <span style="font-size: 20px;">商品名：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入商品名称"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">商品图片：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <div class="demo-upload-list" v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
              <img :src="item.url">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            multiple
            type="drag"
            action="//jsonplaceholder.typicode.com/posts/"
            style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          </Col>
        </Row>

        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">价格：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入价格"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">数量：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入数量"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">姓名：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入姓名"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">联系方式：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入手机号码"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="24">
            <Button type="primary" @click="sumbit">发布</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div v-if="needPublish" style="margin-top: 50px;margin-bottom: 100px;background-color: dimgrey;padding-bottom: 50px;padding-top: 50px">
      <Form>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">商品名：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入商品名称"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">商品图片：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <div class="demo-upload-list" v-for="item in uploadList">
            <template v-if="item.status === 'finished'">
              <img :src="item.url">
              <div class="demo-upload-list-cover">
                <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
              </div>
            </template>
            <template v-else>
              <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="2048"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            multiple
            type="drag"
            action="//jsonplaceholder.typicode.com/posts/"
            style="display: inline-block;width:58px;">
            <div style="width: 58px;height:58px;line-height: 58px;">
              <Icon type="ios-camera" size="20"></Icon>
            </div>
          </Upload>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">商品描述：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input type="textarea" placeholder="请输入商品描述." />
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">价格：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入价格"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">数量：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入数量"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">姓名：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入姓名"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="8" style="text-align: right">
          <span style="font-size: 20px;">联系方式：</span>
          </Col>
          <Col span="8" style="text-align: left">
          <Input placeholder="请输入手机号码"/>
          </Col>
        </Row>
        <Row style="margin-top: 20px">
          <Col span="24">
          <Button type="primary" @click="sumbit">发布</Button>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data () {
      return {
        publish:"商品",
        commodity:true,
        needPublish:false,
        msg: 'Welcome to Your Vue.js App',
        imageData1:{width:'300px',height:'300px'},
        imageData2:{width:'300px',height:'300px'},
        imageData3:{width:'300px',height:'300px'},
        images1:{width:'400px',height:'240px'},
        images2:{width:'400px',height:'240px'},
        images3:{width:'400px',height:'240px'},
        value2:0,
        split3: 0.5,
        split4: 0.5,
        defaultList: [
        ],
        imgName: '',
        visible: false,
        uploadList: [],
      }
    },
    mounted () {
      this.uploadList = this.$refs.upload.fileList;
    },
    methods:{
      sumbit(){
        this.$Message.success("发布成功，请保持电话畅通，等待后台人员审核")
      },
      CommodityChange(){
        this.$router.push({path:'/commodity'})
      },
      changeCommodity01(){
        this.$router.push({path:'/commodity01'})
      },
      changeCommodity02(){
        this.$router.push({path:'/commodity02'})
      },
      changeCommodity03(){
        this.$router.push({path:'/commodity03'})
      },
      changeCommodity04(){
        this.$router.push({path:'/commodity04'})
      },
      changeCommodity05(){
        this.$router.push({path:'/commodity05'})
      },
      changeCommodity06(){
        this.$router.push({path:'/commodity06'})
      },
      PublishChange(){
        this.$router.push({path:'/publish'})
      },
      changePublish01(){
        this.$router.push({path:'/publish01'})
      },
      changePublish02(){
        this.$router.push({path:'/publish02'})
      },
      changePublish03(){
        this.$router.push({path:'/publish03'})
      },
      radioPublish(publish){
        console.log(publish)
        if(publish=="商品"){
          this.commodity=true;
          this.needPublish=false;
        }else if(publish=="需求"){
          this.commodity=false;
          this.needPublish=true;
        }
      },
      handleView (name) {
        this.imgName = name;
        this.visible = true;
      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      },
      handleSuccess (res, file) {
        // file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
        // file.name = '7eb99afb9d5f317c912f08b5212fd69a';
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: '文件格式不正确',
          desc: '文件 ' + file.name + ' 不是图片格式.'
        });
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '超过大小限制',
          desc: '文件  ' + file.name + ' 过大，不能超过2M.'
        });
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5;
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          });
        }
        return check;
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:link{
    color:black;
  }
  a:hover{
    color:red;
  }
  a:active{
    color:darkred;
  }
  .image-into{
    padding:10px;
  }
  .image-out{
    padding:0px;
  }
  .demo-split{
    height: 200px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 200px;
    padding: 0;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .govm-ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    /*background: url("../../assets/images/home_pic.png") no-repeat -87px -31px;*/
    position: relative;
    top: 4px;
    right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue